import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 somewheredeep</p>
    </footer>
  );
};

export default Footer;